module.exports = __webpack_public_path__ + "img/mountains-large.eb781369.png";